import TableRow from '@material-ui/core/TableRow'
import React from 'react'

export default function CustomTableRow({ children, onClick, selected, tabIndex, className, style }) {
  return (
    <TableRow style={style ? style : { backgroundColor: '#F8F8F8' }} onClick={onClick} hover selected={selected} tabIndex={tabIndex} className={className}>
      {children}
    </TableRow>
  )
}
